export default __webpack_public_path__ + "static/media/unarchive-icon.90c320de.svg";